import GameQuestionService from "src/services/GameQuestionService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	REMOVE: "game_question/remove",
	REORDER: "game_question/reorder",
};
export const params = {
	game_id: "",
	question_id: "",
	sort: "",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.gamequestion,
@property  {array}  modules.gamequestions
 **/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {
		[types.REMOVE] (context, model) {
			return GameQuestionService.remove(model.pivotId).then((response) => {
				context.commit(types.REMOVE, model);
				return response;
			});
		},
		[types.REORDER] (context, data) {
			try {
				return GameQuestionService.reorder(data).then((response) => {
					console.log(response);
				});
			} catch (e) {
				throw new Error(e);
			}
		},
	},
	types: types,
};
export default ModuleCreator("game_question", GameQuestionService, module, types, params);
